<template>
    <div style="max-width: 1200px;" class="mx-auto my-8">
        <h3 class="text-center">Cash Flow</h3>
        <v-simple-table dense class="cashflow-table">
            <colgroup>
                <col> <!-- Age -->
                <col class="col-yellow"> <!-- First Mortgage -->
                <col class="col-yellow"> <!-- HELOC -->
                <col class="col-blue"> <!-- Lump Sum at Closing -->
                <col class="col-blue"> <!-- Monthly To Borrower -->
                <col class="col-blue"> <!-- Monthly From Borrower -->
                <col class="col-blue"> <!-- Property Taxes & Insurance -->
                <col> <!-- Total Annual Cash Flow Impact -->
                <col> <!-- Cumulative Cash Flow Impact -->
            </colgroup>

            <thead>
                <tr>
                    <th rowspan="2">Age</th>
                    <th colspan="2" class="text-center">Mortgage Payments no Longer Required</th>
                    <th colspan="4" class="text-center">New Reverse Mortgage Payments</th>
                    <th rowspan="2" class="text-right">Total Annual Cash Flow Impact</th>
                    <th rowspan="2" class="text-right">Cumulative Cash Flow Impact</th>
                </tr>
                <tr>
                    <th class="text-right">First Mortgage</th>
                    <th class="text-right">HELOC</th>
                    <th class="text-right">Lump Sum at Closing</th>
                    <th class="text-right">Monthly To Borrower</th>
                    <th class="text-right">Monthly From Borrower</th>
                    <th class="text-right">Property Taxes &amp; Insurance</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="row in cashFlowSummary" :key="row.age">
                    <td>{{ row.age }}</td>
                    <td class="text-right">{{ formatMoney(row.firstMortgage) }}</td>
                    <td class="text-right">{{ formatMoney(row.heloc) }}</td>
                    <td class="text-right">{{ formatMoney(row.lumpSumAtClosing) }}</td>
                    <td class="text-right">{{ formatMoney(row.monthlyToBorrower) }}</td>
                    <td class="text-right">{{ formatMoney(row.monthlyFromBorrower) }}</td>
                    <td class="text-right">{{ formatMoney(row.propertyTaxesAndInsurance) }}</td>
                    <td class="text-right">{{ formatMoney(row.totalAnnualCashFlowImpact) }}</td>
                    <td class="text-right">{{ formatMoney(row.cumulativeCashFlowImpact) }}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import helpers from '../../helpers';

export default {
    methods: {
        formatMoney: helpers.formatMoney,
    },
    computed: {
        currentScenarioTitle() {
            return this.$store.state.scenarioData.scenario;
        },
        allScenariosTitles() {
            return this.$store.state.scenarioData.allScenarioTitles;
        },
        cashFlowSummary() {
            console.log(this.$store.state.scenarioData.currentScenarioData.finalValues.tableValues.cashFlowSummary)
            return this.$store.state.scenarioData.currentScenarioData.finalValues.tableValues.cashFlowSummary
        }
    },
};
</script>


<style>
/* not scoped? drop :deep() */
.cashflow-table col.col-yellow {
    background-color: hsla(48, 100%, 50%, .12);
}

.cashflow-table col.col-blue {
    background-color: hsla(199, 100%, 40%, .10);
}
</style>
